import { render } from "./FeedMenuControl.vue?vue&type=template&id=2df97130&scoped=true"
import script from "./FeedMenuControl.vue?vue&type=script&lang=js"
export * from "./FeedMenuControl.vue?vue&type=script&lang=js"

import "./FeedMenuControl.vue?vue&type=style&index=0&id=2df97130&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df97130"]])

export default __exports__